<template>
    <div class="login-page">
        <img :src="stadaLogo" class="logo"/>
        <form>
            <h2 class="login-title">Bejelentkezés</h2>
            <input type="text" v-model="userName" placeholder="Felhasználó Név"/>
            <input type="password" v-model="userPassword" placeholder="Jelszó"/>
        <div class="error" v-if="this.error">Hibás adatok!</div>
        <input type="submit" class="btn" @click="login($event)" value="Indít"/>
        </form>
    </div>
</template>

<script>
import stadaLogo from '@/assets/img/stada_logo_cmyk_color.png';

export default {
    data: () => {
        return {
            loggedIn: false,
            error: false,
            vm : this,
            userName : '',
            userPassword : '',
            stadaLogo
        }
    },
    beforeCreate () {
        var vm = this;
        if(vm.$store.state.privateKey !== '') {
            vm.axios.post('/backend/web/validation', vm.$store.state.privateKey).then((response) => {
                if(response.data !== false){
                    this.$router.push({ path: "/StartQuiz" });
                } 
            });
        }
    },
    methods: {
        login(event) {
            event.preventDefault();
            var loginData = {
                'user_name': this.userName,
                'user_password' : this.userPassword
            }    
            this.axios.post('/backend/web/login', loginData).then((response) => {
                var vm = this;
                vm.error = false;
                if( response.data.privateKey !== undefined) {
                    vm.$store.state.privateKey = response.data.privateKey;
                    localStorage.setItem("stada_private_key", response.data.privateKey);
                    vm.$router.push({ path: "/StartQuiz" });
                } else {
                    vm.error = true;
                }
            });
        }
    }
}

   
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/assets/sass/base/variables';
    .login-page {
        .logo{
            width: 220px;
            height: 127.5px;
            object-fit: contain;
            margin-top: 150px;
            margin-bottom: 0px;
        }

        h2{
            font-size: 21px;
            color: #4a4a4a;
            margin-top: 61.5px;
            margin-bottom: 31px;
        }
    }

</style>
